import React, { useEffect, useState } from 'react'
import { useParams, withRouter } from 'react-router-dom'

import { post } from '../helpers/request'
import t from '../helpers/i18n'

const LoginOverrideView = ({ history }) => {
  const { email } = useParams()
  const [error, setError] = useState()

  useEffect(() => {
    post('/login/override/' + email)
      .then(() => history.push('/'))
      .catch(setError)
  }, [email, history])

  return (
    <div>{t('Redirecting')}... {error && error.toString()}</div>
  )
}

export default withRouter(LoginOverrideView)